/* eslint-disable jsx-a11y/anchor-is-valid */
import { Upload } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';

export default () => (
	<Box
		sx={{ p: 1 }}
		display="flex"
		flexDirection="column"
		justifyContent="center"
		alignItems="center"
	>
		<Upload />
		<Typography whiteSpace="pre-line" textAlign="center">
			{intl.tr('styleEditor.logo.dnd.message')}
		</Typography>
	</Box>
);
